/* eslint-disable import/no-named-as-default */
import {Stack} from "@mui/material";
import Form from "../Components/Form";
import InputGroup from "../Components/FormComponents/InputGroup";
import {Link, useLocation, useNavigate} from "react-router-dom";
import Page from "../Components/Page";
import Card from "../Components/Card";
import {login} from "../Util/firebase";

export default function Login() {
    const location = useLocation();
    const navigate = useNavigate();
    const redirect = location.state?.redirect;

    const fLogin = async (e:any) => {
        await login(e).catch((error) => {
            console.log("Error!");
            throw error;
        }).then(() => {
            if (redirect) {
                navigate(redirect);
            }
        });
    };

    return (
        <Page
            metaTitle="Scimos | Login"
            metaDesc="Sign in to Scimos"
            fullHeight>
            <Card title={"Sign in"}>
                <Form onSubmit={fLogin}>
                    <InputGroup name='email' type='email' label='Email' autoComplete='email' required/>
                    <InputGroup name='password' type='password' label='Password' autoComplete='password' required/>
                    <Stack flexDirection={"row"} justifyContent={"space-between"} spacing={0}>
                        <Link to="/register">Register</Link>
                        <Link style={{textAlign: "right"}} to={"/reset/password"}>Reset password</Link>
                    </Stack>
                </Form>
            </Card>
        </Page>

    );
}

